export default 'M 21.903 20 L 15.382 13.479 L 16.739 12.121 L 24.618 20 L 16.739 27.879 L 15.382 26.521 L 21.903 20 Z';
